import * as BillingAndPackage from "./BillingAndPackage";
import * as HolidaySetting from "./HolidaySetting";

const SequencePattern: Record<string, Record<string, Record<string, any>>> = {
  BillingAndPackage: {
    default: {
      START: BillingAndPackage.Start,
      Action: BillingAndPackage.Action,
    },
  },
  HolidaySetting: {
    default: {
      START: HolidaySetting.Start,
      Action: HolidaySetting.Action,
    },
  },
};

export default SequencePattern;
